import Link from '@commons/components/Link';

import type { ArticleNodeProps } from '.';

/**
 * Article node component for the Label display type.
 */

const ArticleNodeLabel = ({ title, alias }: ArticleNodeProps) => {
  return <Link href={alias}>{title}</Link>;
};

export default ArticleNodeLabel;
